import { IconButton, IconButtonProps } from '@chakra-ui/react';
import { FC } from 'react';

interface Props extends IconButtonProps {
  toggleFavorite?: VoidFunction;
}

export const FavoriteButton: FC<Props> = ({ toggleFavorite, ...props }) => {
  return (
    <IconButton
      {...props}
      layerStyle='floatCardButton'
      borderRadius='8px'
      isLoading={!toggleFavorite}
      onClick={toggleFavorite}
      variant='text'
    />
  );
};
